import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUpData, getTablebySql } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnResizable from "@shared/components/SnResizable";
import { showDialog } from "@widgets/CommonDialog";
import usePanelSizes from "@shared/hooks/usePanelSizes";

interface popupProps {
  modalRef?: any;
}

interface RowData {
  KeyField?: string;
  [key: string]: any;
}

const SN_MAS_BAS_REG_001_TEX_POP_002 = forwardRef(
  ({ modalRef }: popupProps, ref) => {
    //#region Variable
    const { userInfo } = global();
    //#endregion
    const [popupParent, setPopupParent] = useState<any>(null);
    //#region Components useState
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
    });

    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
    });
    //#endregion

    //#region grid 길이 관련
    const cd_menu = modalRef.cd_menu || "SN_MAS_BAS_REG_001_TEX_POP_002";
    const defaultSize = { panel1width: "49.5%", panel2width: "49.5%" };
    const [sizes, onResizeStop] = usePanelSizes(cd_menu, defaultSize);
    //#endregion
    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);
    useImperativeHandle(ref, () => ({
      getSelectedValue: () => {
        onSave();
      },
      getSelectedRow: () => [
        gridRefs.current["grid2"].current.getChange() || [],
      ],
    }));

    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData(
            "SN_MAS_BAS_REG_001_TEX_POP_002",
            {}
          );
          setFormData(rtn.formData); // 조회조건 초기값
          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          setColums({
            grid1: rtn.grid.grid1,
            grid2: rtn.grid.grid2,
          });
          onSearch();
        } catch (error) {}
      };
      fetchform();
    }, []);

    //#region onSearch
    const onSearch = async () => {
      try {
        const param = {
          id: "sn_mas_bas_reg_001_tex_pop_002_01",
          params: { cd_firm: userInfo.cd_firm },
        };

        const data: any = await fnGetDataSet(param);
        setDataSources({
          grid1: data[0],
          grid2: data[1],
        });
        if (data[0] && data[0].length > 0) {
          await new Promise((resolve) => setTimeout(resolve, 50));
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
        } else {
          gridRefs.current["grid2"].current.resetUpdate();
        }
      } catch (error) {}
    };
    //#endregion

    //region onAddRow
    const onAddRow = async () => {
      try {
        const selectedNode = gridRefs.current["grid1"].current.focusedRowNode();
        const maxNoLine =
          gridRefs.current["grid2"].current.getMaxValue("no_line");
        const newRow = {
          cd_firm: userInfo?.cd_firm,
          no_line: maxNoLine + 1,
          tp_item: selectedNode.data?.cd_flag,
          cd_clas: "",
          yn_itemcode: "N",
          nm_clas: "",
        };
        return gridRefs.current["grid2"].current?.addRow(newRow);
      } catch (error: any) {}
    };

    //region onDeleteRow
    const onDeleteRow = async () => {
      gridRefs.current["grid2"].current.deleteSelectedRows();
    };

    //region onBeforeAddRowL
    //region onSave
    const onSave = async () => {
      try {
        let SaveData: any = {};
        gridRefs.current["grid2"].current.stopEditing();

        const requiredValuesCheck =
          gridRefs.current["grid2"].current.requiredValuesCheck();
        if (!requiredValuesCheck) {
          return;
        }

        const gridGetChanges = gridRefs.current["grid2"].current.getChange();
        if (gridGetChanges.modifiedRowcount == 0) {
          await showDialog("alter", "변경된 내용이 없습니다.");
          return;
        }

        SaveData["sys_styleconfig_tex"] = gridGetChanges;
        await fnSave("SN_MAS_BAS_REG_001_TEX_POP_002_SAVE_O1", SaveData);
        gridRefs.current["grid2"].current.resetUpdate();

        SaveData = [];
      } catch (error: any) {}
    };
    //#endregion

    //#region onFocusedRowChanged
    const onFocusedRowChanged = (event: any) => {
      const selectedRow = event;
      if (selectedRow) {
        const tp_item = selectedRow.cd_flag;
        gridRefs.current["grid2"].current.applyFilters({ tp_item: tp_item });
        gridRefs.current["grid2"].current.selectAndFocusRow(0);
      } else {
        return;
      }
    };
    //#endregion

    //#region CellchangedH
    const onCellValueChangedL = async (event: any) => {
      if (!event) return;
      const colId = event.colId;
      const rowData = event.rowData;
      const rowNode = event.rowNode;

      switch (colId) {
        case "cd_clas":
          const upperCdClas = rowData.cd_clas?.toUpperCase() || "";
          rowNode.setDataValue("cd_clas", upperCdClas, "noEvent");

          const sqlQuery = {
            sql: "select nm_clas from mas_codeh where cd_firm = :cd_firm and cd_clas = :cd_clas",
            cd_firm: userInfo.cd_firm,
            cd_clas: rowData.cd_clas,
          };
          const params = await getTablebySql(sqlQuery);

          if (params != null && params.length > 0) {
            rowNode.setDataValue("nm_clas", params[0].nm_clas, "noEvent");
          } else {
            rowNode.setDataValue("nm_clas", "", "noEvent");
          }
          break;
      }
    };
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged: onFocusedRowChanged,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onBtnAddClick: onAddRow,
            onBtnDeleteClick: onDeleteRow,
            onCellValueChanged: onCellValueChangedL,
          },
        },
      }),
      [columns, dataSources]
    );
    //#region UI
    return (
      <div className="h-full flex flex-col">
        <div className="flex w-full h-full min-w-0 space-x-1.5">
          <SnResizable
            direction={"width"}
            seq={1}
            cd_menu={cd_menu}
            defaultSize={defaultSize}
            size={sizes.panel1width}
            onResizeStop={onResizeStop}
            enable={{ right: true }}
            minWidth={130}
          >
            <SnGrid
              ref={gridRefs.current["grid1"]}
              columnConfig={grids.grid1.columns}
              rowData={grids.grid1.dataSource}
              etcProps={{
                rowSelection: "single",
                title: "품목유형",
              }}
              events={grids.grid1.events}
            />
          </SnResizable>
          <SnResizable
            direction={"width"}
            seq={2}
            cd_menu={cd_menu}
            defaultSize={defaultSize}
            size={sizes.panel2width}
            onResizeStop={onResizeStop}
            enable={{ right: true }}
            minWidth={130}
          >
            <SnGrid
              ref={gridRefs.current["grid2"]}
              columnConfig={grids.grid2.columns}
              rowData={grids.grid2.dataSource}
              etcProps={{
                rowSelection: "single",
                title: "규격항목",
                isEditable: true,
                popupParent: popupParent,
              }}
              events={grids.grid2.events}
            />
          </SnResizable>
        </div>
      </div>
    );
  }
  //#endregion
);

export default SN_MAS_BAS_REG_001_TEX_POP_002;
